<app-page-meta pageTitle="finzy - Investment Application Summary"></app-page-meta>
<app-header></app-header>
<div class="row mainrow">
  <div class="col-sm-4 leftdiv">
    <app-lenderleftdiv></app-lenderleftdiv>
  </div>
  <div class="col-sm-8 rightdiv">
    <div class="mobileleftdiv"></div>
    <div class="rightinnerdiv">
      <p class="headtxt">Quick review</p>

      <div class="row greydiv">
        <div class="row">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">Name</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{name}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">PAN</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{pan}}</p>
          </div>
        </div>
        <div class="row" *ngIf="docno">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">{{document}}</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{docno}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">Mobile</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{mobile_no}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">Nominee Name</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{nomineeName ? nomineeName : '-'}}</p>
          </div>

        </div>
      </div>

      <p class="greytxthead" style="margin-top: 30px;margin-bottom: 15px;">BANK DETAILS</p>
      <div class="row greydiv">
        <div class="row">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">Bank Name</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{bank_name}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">Account Number</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{account_no}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5 summarydetails">
            <p class="greytxt">IFSC</p>
          </div>
          <div class="col-xs-7 summarydetails1">
            <p class="greytxt">{{bank_ifsc}}</p>
          </div>

        </div>
      </div>
      <div class="row mt-3">
        <p class="text-error col-sm-12 col-xs-12" *ngIf="errorMsg !== ''">{{ errorMsg }}</p>
      </div>

      <div class="row buttondiv">
        <div class="col-sm-6 backbtn">
          <button mat-stroked-button class="button-back primary" *ngIf="hideSubmit" [routerLink]="['../lenderuploaddocuments']"><i
                  class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp; BACK
          </button>
        </div>
        <div class="col-sm-6 moveright">
          <app-forward-button class="button-forward" [disabled]="!allStepsComplete" [isLoading]="loader"
                              (click)="startInvesting($event); analyticsTracker.trackButtonClick('Lender Summary','START INVESTING')">START INVESTING</app-forward-button>
        </div>
      </div>

    </div>
  </div>
</div>


<app-footer></app-footer>





